import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { InfoIcon } from '@components/ui/svgIcons'
import { Tooltip } from '@components/ui/Tooltips'

const IconWrapper = styled.span`
  color: ${({ theme }) => theme.colors.common.inputLabel};
  display: inline-flex;
  cursor: help;
  align-items: center;
  width: 22px;
`

/**
 * Simple component to display a tooltip with a message when a payment is not editable.
 */
export function NotEditablePaymentTooltip() {
  return (
    <Tooltip
      title={
        <FormattedMessage
          id="paymentDetails.permission.tooltip"
          defaultMessage="Ebben az utalási csomagban számodra nem látható tételek is vannak, ezért nem szerkesztheted ezt."
        />
      }
      placement="left"
    >
      <IconWrapper data-testid="not-editable-info">
        <InfoIcon size={20} />
      </IconWrapper>
    </Tooltip>
  )
}
